import _ from "lodash";
import { getUnitTypeOptionsMemoized } from "UnitPlans/modules/UnitPlanModule";
import { getMemoizedLangFunction, getMemoizedFunction } from "Utils";

const getFilterOptions = ({
  t,
  curriculumProgramType,
  organizationId,
  coursesList,
  gradesList,
  subjectsList,
  themesList,
  includedFiltersMapping,
  creatorList,
}) => {
  let unitTypeOptions = [],
    courseOptions = [],
    gradeOptions = [],
    subjectOptions = [],
    creatorOptions = [],
    themeOptions = [];

  if (includedFiltersMapping.unitType) {
    unitTypeOptions = getUnitTypeOptionsMemoized({
      t,
      organizationId,
      curriculumType: curriculumProgramType,
    });
  }

  if (includedFiltersMapping.course) {
    courseOptions = _.map(_.get(coursesList, "edges", []), ({ node }) => {
      const { id, title } = node;
      return { key: id, label: title, value: id };
    });
  }

  if (includedFiltersMapping.grade) {
    gradeOptions = _.map(gradesList, grade => ({
      label: grade.name,
      key: grade.id,
      value: grade.id,
    }));
  }

  if (includedFiltersMapping.subject) {
    subjectOptions = _.map(subjectsList, subject => {
      return {
        label: subject.name,
        key: subject.id,
        value: subject.id,
        isArchived: _.get(subject, "isArchived", false),
      };
    });
  }

  if (includedFiltersMapping.theme) {
    themeOptions = _.map(themesList, theme => {
      return {
        label: theme.label,
        key: theme.id,
        value: theme.id,
      };
    });
  }

  if (includedFiltersMapping.creator) {
    creatorOptions = _.map(creatorList, creator => {
      return {
        label: creator.label,
        key: creator.value,
        value: creator.value,
        isArchived: creator.isArchived || false,
      };
    });
  }

  return {
    courseOptions,
    unitTypeOptions,
    gradeOptions,
    subjectOptions,
    themeOptions,
    creatorOptions,
  };
};

export const getFilterOptionsMemoized = getMemoizedLangFunction(
  getFilterOptions
);

const getUpdatedFilters = ({
  selectedUnitTypes,
  searchText,
  filters: filtersFromProps,
}) => {
  return {
    unitType: selectedUnitTypes,
    searchText,
    // spread props at last to avoid overriding
    ...filtersFromProps,
  };
};

export const getUpdatedFiltersMemoized = getMemoizedFunction(getUpdatedFilters);
